import team1 from '../assets/images/team/01.jpg'
import team2 from '../assets/images/team/02.jpg'

import {LuUser2, LuBriefcase, LuHeart} from '../assets/icons/vander'

export const featureData = [
    {
        icon:'mdi mdi-layers-triple-outline',
        title:'Fresh Layouts',
        desc:"The most well-known dummy text is the 'Lorem', which well-known is said which is said to have in."
    },
    {
        icon:'mdi mdi-responsive',
        title:'Fully Responsive',
        desc:"One disadvantage of Lorum Ipsum is that in certain letters which is said appear more than."
    },
    {
        icon:'mdi mdi-clipboard-flow-outline',
        title:'Modern Workflow',
        desc:"Moreover, in Latin only words at the beginning of sentences which is said are capitalized."
    },
    {
        icon:'mdi mdi-lightbulb-outline',
        title:'Minimalism Feast',
        desc:"If the fill text is intended to illustrate the characteristics well-known which is said of sometimes."
    },
    {
        icon:'mdi mdi-account-heart-outline',
        title:'Customer Care',
        desc:"There is now an abundance of readable dummy texts. These are which well-known is said text is."
    },
    {
        icon:'mdi mdi-google',
        title:'Free Fonts',
        desc:"These alternatives to the classic are often amusing and tell short, which is said stories."
    },
]

export const counterData = [
    {
        icon:'mdi mdi-school-outline',
        target:'2500',
        title:'User Worldwide'
    },
    {
        icon:'mdi mdi-book-open-variant',
        target:'20000',
        title:'Download'
    },
    {
        icon:'mdi mdi-account',
        target:'11',
        title:'Team Members'
    },
    {
        icon:'mdi mdi-language-swift',
        target:'9',
        title:'Rating'
    },
]

export const teamData = [
    {
        image:team1,
        name:'Martin Dongre',
        position:'Founder',
        desc:'I must explain to you how all this mistaken idea of denouncing pleasure and system.',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:team2,
        name:'Lisa Marvel',
        position:'C.E.O.',
        desc:'I must explain to you how all this mistaken idea of denouncing pleasure and system.',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
]

export const skillData = [
    {
        title:'WordPress',
        progress:'84%'
    },
    {
        title:'PHP / MYSQL',
        progress:'75%'
    },
    {
        title:'Angular / JavaScript',
        progress:'79%'
    },
    {
        title:'HTML',
        progress:'95%'
    },
]

export const pricingData = [
    {
        title:'Individual',
        value:'39',
        feature:['Full Access','Source Files','Free Appointments'],
        btnText:'Get Started',
        icon:LuUser2
    },
    {
        title:'Enterprise',
        value:'79',
        feature:['Full Access','Source Files','Free Appointments','Enhanced Security'],
        btnText:'Buy Now',
        icon:LuBriefcase
    },
    {
        title:'Premium',
        value:'99',
        feature:['Full Access','Source Files','Free Appointments','Enhanced Security','24 / 7 Support'],
        btnText:'Buy Now',
        icon:LuHeart
    },
]
